import './styles.scss';

import ScrollReveal from 'scrollreveal';

const globalAnimationDelay = 500;
const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');
const isInternetExplorer =
  msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./);

/**
 * Make sure that any changes to the below selector lists are mirrored in the
 * Sass file `./styles.scss`.
 */
const revealElements = [
  'body.home header',
  'body.home #home-hero',
  'body.home .page-content',
  'body.home .page-content .card',
  "body.home footer [class*='col-']",
  'body.home footer .col',
];

const simpleFadeElements = [
  'body.home header .navbar',
  'body.home header>img',
  'body.home #search-collapse > form',
];

const logoElements = "body.home header img[title='Logo']";

function instantReveal() {
  const elemsToReveal = [];
  elemsToReveal.push(revealElements);
  elemsToReveal.push(logoElements);

  document.querySelectorAll(elemsToReveal.join(',')).forEach((element) => {
    element.style.visibility = 'visible';
  });

  document.querySelectorAll(simpleFadeElements.join(',')).forEach((element) => {
    element.classList.add('revealed');
  });
}

function registerEventListeners() {
  /**
   * Lazy load animated SVG, considering IE support.
   */
  document.addEventListener('DOMContentLoaded', function () {
    // If Internet Explorer, use the alternative image URL
    const srcAttribute = isInternetExplorer ? 'data-src-ie' : 'data-src';

    const imagesToLoad = [
      'design-elem-header',
      'design-elem-featured',
      'design-elem-footer',
    ];

    imagesToLoad.forEach((imageElemId) => {
      const imageElem = document.getElementById(imageElemId);
      if (imageElem) {
        imageElem.setAttribute('src', imageElem.getAttribute(srcAttribute));
      }
    });
  });

  /**
   * ScrollReveal animations.
   */
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      ScrollReveal().reveal(revealElements.join(','), {
        distance: '0', // This needs to be here so that `transform` is included in the generated transition property
        interval: 125,
      });
    }, globalAnimationDelay);
  });

  // Fade and slide-in the logo from the left
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      ScrollReveal().reveal(logoElements, {
        delay: 0,
        distance: '0.5rem',
        origin: 'left',
      });
    }, globalAnimationDelay);
  });

  // Simple fade in for elements with dropdowns, to avoid z-index issues.
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      const elements = document.querySelectorAll(simpleFadeElements.join(','));
      for (const element in elements) {
        if (Object.hasOwnProperty.call(elements, element)) {
          elements[element].classList.add('revealed');
        }
      }
    }, globalAnimationDelay);
  });
}

export default function initScrollReveal() {
  if (isInternetExplorer) {
    instantReveal();
  } else {
    registerEventListeners();
  }
}
